import webBackApi from '../../api/webBackApi';

const API_PATH = "/api/v1/ftp-users";

export const createFtpUser = async (ftpUserData) => {
  try {
    const response = await webBackApi.post(API_PATH, ftpUserData);
    return response.data;
  } catch (error) {
    console.error("Error creating FTP user:", error);
    throw error;
  }
};

export const getAllFtpUsers = async () => {
  try {
    const response = await webBackApi.get(API_PATH);
    return response.data;
  } catch (error) {
    console.error("Error fetching FTP users:", error);
    throw error;
  }
};

export const getFtpUserById = async (id) => {
  try {
    const response = await webBackApi.get(`${API_PATH}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching FTP user with id ${id}:`, error);
    throw error;
  }
};

export const updateFtpUser = async (id, ftpUserData) => {
  try {
    const response = await webBackApi.put(`${API_PATH}/${id}`, ftpUserData);
    return response.data;
  } catch (error) {
    console.error(`Error updating FTP user with id ${id}:`, error);
    throw error;
  }
};

export const deleteFtpUser = async (id) => {
  try {
    const response = await webBackApi.delete(`${API_PATH}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting FTP user with id ${id}:`, error);
    throw error;
  }
};

export const getPlainCode = async (customerId, camIdentifier) => {
  try {
    const response = await webBackApi.post(`${API_PATH}/plain-code`, {
      customerId,
      camIdentifier,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching plain code:", error);
    throw error;
  }
};
